import {useContext} from 'react'
import {Link, useParams} from 'react-router-dom'
import styled from 'styled-components'
import {colors} from "../../utils/colors";
import {ErrorWrapper, Loader} from "../../utils/styles/Atoms";
import {SurveyContext} from "../../utils/context";
import {useFetch} from "../../utils/hooks";

const SurveyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const QuestionTitle = styled.h2`
  text-decoration: underline;
  text-decoration-color: ${colors.primary};
`

const QuestionContent = styled.span`
  margin: 30px;
`

const LinkWrapper = styled.div`
  padding-top: 30px;

  & a {
    color: black;
  }

  & a:first-of-type {
    margin-right: 20px;
  }
`

const ReplyBox = styled.button<{ $isSelected: boolean }>`
  border: none;
  height: 100px;
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.backgroundLight};
  border-radius: 30px;
  cursor: pointer;
  box-shadow: ${({$isSelected}) => $isSelected ?
          `0px 0px 0px 2px ${colors.primary} inset`
          :
          'red'
  };

  &:first-child {
    margin-right: 15px;
  }

  &:last-of-type {
    margin-left: 15px;
  }
`

const ReplyWrapper = styled.div`
  display: flex;
  flex-direction: row;
`

export function Survey() {

    // getsurvey, error and isLoading
    const {data, error, isLoading} = useFetch<string[]>('/survey')

    const {questionNumber} = useParams()
    const questionNumberInt = parseInt(questionNumber!)
    const prevQuestionNumber = questionNumberInt === 1 ? 1 : questionNumberInt - 1
    const nextQuestionNumber = questionNumberInt + 1
    const {saveAnswers, answers} = useContext(SurveyContext)

    function saveReply(answer) {
        saveAnswers({[questionNumber!]: answer})
    }

    if (error) {
        return <ErrorWrapper>Oups il y a eu un problème</ErrorWrapper>
    }

    return (
        <SurveyContainer>
            <QuestionTitle>Question {questionNumber}</QuestionTitle>
            {isLoading ? (
                <Loader/>
            ) : (
                <QuestionContent>{data[questionNumber!]}</QuestionContent>
            )}
            {(answers && !isLoading) && (
                <ReplyWrapper>
                    <ReplyBox
                        onClick={() => saveReply(true)}
                        $isSelected={answers[questionNumber!] === true}
                    >
                        Oui
                    </ReplyBox>
                    <ReplyBox
                        onClick={() => saveReply(false)}
                        $isSelected={answers[questionNumber!] === false}
                    >
                        Non
                    </ReplyBox>
                </ReplyWrapper>
            )}
            <LinkWrapper>
                <Link to={`/survey/${prevQuestionNumber}`}>Précédent</Link>
                {data[questionNumberInt + 1] ? (
                    <Link to={`/survey/${nextQuestionNumber}`}>Suivant</Link>
                ) : (
                    <Link to="/results">Résultats</Link>
                )}
            </LinkWrapper>
        </SurveyContainer>
    )
}
